// extracted by mini-css-extract-plugin
export default {"heading":"signature-results_heading__cuk0y"};